// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offer-page {

    min-height: 100vh;

    background: #f8fafc;

    padding: 40px;

}


.offer-header {

    max-width: 1100px;

    margin: auto;

    background: white;

    border-radius: 30px;

    padding: 35px;

    display: flex;

    align-items: center;

    gap: 25px;

    margin-bottom: 30px;

    border: 1px solid rgba(0, 0, 0, .05);

    box-shadow:
        0 10px 40px rgba(0, 0, 0, .04);

}


.offer-avatar img,
.offer-avatar {

    width: 90px;

    height: 90px;

    border-radius: 25px;

    overflow: hidden;

    object-fit: cover;

    display: flex;

    justify-content: center;

    align-items: center;

    background:

        var(--primary-100);

    color: white;

    font-size: 35px;

}


.offer-header-info h1 {

    margin: 5px 0;

    color: #111827;

    font-size: 32px;

}


.offer-header-info p {

    color: #64748b;

}


.offer-active {

    display: inline-flex;

    padding: 8px 15px;

    border-radius: 30px;

    background:

        rgba(var(--primary-100-rgb),
            .1);

    color:

        var(--primary-100);

    font-weight: 700;

    font-size: 13px;

}


.offer-content {

    max-width: 1100px;

    margin: auto;

}


.offer-card {

    background: white;

    padding: 35px;

    border-radius: 30px;

    margin-bottom: 25px;

    border: 1px solid rgba(0, 0, 0, .05);

    box-shadow:
        0 10px 40px rgba(0, 0, 0, .04);

}


.offer-card h2 {

    color: #111827;

    margin-bottom: 25px;

}


.offer-card p {

    line-height: 1.8;

    color: #475569;

}


.offer-profile-grid {

    display: grid;

    grid-template-columns:
        repeat(auto-fit,
            minmax(220px,
                1fr));

    gap: 20px;

}


.profile-item {

    padding: 18px;

    border-radius: 20px;

    background: #f8fafc;

    border: 1px solid rgba(0, 0, 0, .05);

}


.profile-item span {

    display: block;

    color: #64748b;

    margin-bottom: 8px;

    font-size: 13px;

    text-transform: capitalize;

}


.profile-item strong {

    color: #111827;

}


.offer-apply-btn {

    width: 100%;

    padding: 18px;

    border: none;

    border-radius: 18px;

    background:

        var(--primary-100);

    color: white;

    font-size: 16px;

    font-weight: 700;

    cursor: pointer;

    transition: .3s;

}


.offer-apply-btn:hover {

    background:

        var(--primary-200);

    transform:
        translateY(-2px);

}


@media(max-width:768px) {

    .offer-page {

        padding: 20px;

    }

    .offer-header {

        flex-direction: column;
        align-items: flex-start;

    }

    .offer-header-info h1 {

        font-size: 24px;

    }

}


.role-warning {

    padding: 15px;

    border-radius: 16px;

    background:
        rgba(239,
            68,
            68,
            0.08);

    color:
        #dc2626;

    font-weight: 600;

    text-align: center;

}


.offer-apply-btn.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
    filter: grayscale(100%);
}`, "",{"version":3,"sources":["webpack://./src/componentsL/OfferDetails.css"],"names":[],"mappings":"AAAA;;IAEI,iBAAiB;;IAEjB,mBAAmB;;IAEnB,aAAa;;AAEjB;;;AAGA;;IAEI,iBAAiB;;IAEjB,YAAY;;IAEZ,iBAAiB;;IAEjB,mBAAmB;;IAEnB,aAAa;;IAEb,aAAa;;IAEb,mBAAmB;;IAEnB,SAAS;;IAET,mBAAmB;;IAEnB,oCAAoC;;IAEpC;sCACkC;;AAEtC;;;AAGA;;;IAGI,WAAW;;IAEX,YAAY;;IAEZ,mBAAmB;;IAEnB,gBAAgB;;IAEhB,iBAAiB;;IAEjB,aAAa;;IAEb,uBAAuB;;IAEvB,mBAAmB;;IAEnB;;0BAEsB;;IAEtB,YAAY;;IAEZ,eAAe;;AAEnB;;;AAGA;;IAEI,aAAa;;IAEb,cAAc;;IAEd,eAAe;;AAEnB;;;AAGA;;IAEI,cAAc;;AAElB;;;AAGA;;IAEI,oBAAoB;;IAEpB,iBAAiB;;IAEjB,mBAAmB;;IAEnB;;;eAGW;;IAEX;;0BAEsB;;IAEtB,gBAAgB;;IAEhB,eAAe;;AAEnB;;;AAGA;;IAEI,iBAAiB;;IAEjB,YAAY;;AAEhB;;;AAGA;;IAEI,iBAAiB;;IAEjB,aAAa;;IAEb,mBAAmB;;IAEnB,mBAAmB;;IAEnB,oCAAoC;;IAEpC;sCACkC;;AAEtC;;;AAGA;;IAEI,cAAc;;IAEd,mBAAmB;;AAEvB;;;AAGA;;IAEI,gBAAgB;;IAEhB,cAAc;;AAElB;;;AAGA;;IAEI,aAAa;;IAEb;;;qBAGiB;;IAEjB,SAAS;;AAEb;;;AAGA;;IAEI,aAAa;;IAEb,mBAAmB;;IAEnB,mBAAmB;;IAEnB,oCAAoC;;AAExC;;;AAGA;;IAEI,cAAc;;IAEd,cAAc;;IAEd,kBAAkB;;IAElB,eAAe;;IAEf,0BAA0B;;AAE9B;;;AAGA;;IAEI,cAAc;;AAElB;;;AAGA;;IAEI,WAAW;;IAEX,aAAa;;IAEb,YAAY;;IAEZ,mBAAmB;;IAEnB;;0BAEsB;;IAEtB,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,eAAe;;AAEnB;;;AAGA;;IAEI;;0BAEsB;;IAEtB;wBACoB;;AAExB;;;AAGA;;IAEI;;QAEI,aAAa;;IAEjB;;IAEA;;QAEI,sBAAsB;QACtB,uBAAuB;;IAE3B;;IAEA;;QAEI,eAAe;;IAEnB;;AAEJ;;;AAGA;;IAEI,aAAa;;IAEb,mBAAmB;;IAEnB;;;;iBAIa;;IAEb;eACW;;IAEX,gBAAgB;;IAEhB,kBAAkB;;AAEtB;;;AAGA;IACI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;AAC3B","sourcesContent":[".offer-page {\n\n    min-height: 100vh;\n\n    background: #f8fafc;\n\n    padding: 40px;\n\n}\n\n\n.offer-header {\n\n    max-width: 1100px;\n\n    margin: auto;\n\n    background: white;\n\n    border-radius: 30px;\n\n    padding: 35px;\n\n    display: flex;\n\n    align-items: center;\n\n    gap: 25px;\n\n    margin-bottom: 30px;\n\n    border: 1px solid rgba(0, 0, 0, .05);\n\n    box-shadow:\n        0 10px 40px rgba(0, 0, 0, .04);\n\n}\n\n\n.offer-avatar img,\n.offer-avatar {\n\n    width: 90px;\n\n    height: 90px;\n\n    border-radius: 25px;\n\n    overflow: hidden;\n\n    object-fit: cover;\n\n    display: flex;\n\n    justify-content: center;\n\n    align-items: center;\n\n    background:\n\n        var(--primary-100);\n\n    color: white;\n\n    font-size: 35px;\n\n}\n\n\n.offer-header-info h1 {\n\n    margin: 5px 0;\n\n    color: #111827;\n\n    font-size: 32px;\n\n}\n\n\n.offer-header-info p {\n\n    color: #64748b;\n\n}\n\n\n.offer-active {\n\n    display: inline-flex;\n\n    padding: 8px 15px;\n\n    border-radius: 30px;\n\n    background:\n\n        rgba(var(--primary-100-rgb),\n            .1);\n\n    color:\n\n        var(--primary-100);\n\n    font-weight: 700;\n\n    font-size: 13px;\n\n}\n\n\n.offer-content {\n\n    max-width: 1100px;\n\n    margin: auto;\n\n}\n\n\n.offer-card {\n\n    background: white;\n\n    padding: 35px;\n\n    border-radius: 30px;\n\n    margin-bottom: 25px;\n\n    border: 1px solid rgba(0, 0, 0, .05);\n\n    box-shadow:\n        0 10px 40px rgba(0, 0, 0, .04);\n\n}\n\n\n.offer-card h2 {\n\n    color: #111827;\n\n    margin-bottom: 25px;\n\n}\n\n\n.offer-card p {\n\n    line-height: 1.8;\n\n    color: #475569;\n\n}\n\n\n.offer-profile-grid {\n\n    display: grid;\n\n    grid-template-columns:\n        repeat(auto-fit,\n            minmax(220px,\n                1fr));\n\n    gap: 20px;\n\n}\n\n\n.profile-item {\n\n    padding: 18px;\n\n    border-radius: 20px;\n\n    background: #f8fafc;\n\n    border: 1px solid rgba(0, 0, 0, .05);\n\n}\n\n\n.profile-item span {\n\n    display: block;\n\n    color: #64748b;\n\n    margin-bottom: 8px;\n\n    font-size: 13px;\n\n    text-transform: capitalize;\n\n}\n\n\n.profile-item strong {\n\n    color: #111827;\n\n}\n\n\n.offer-apply-btn {\n\n    width: 100%;\n\n    padding: 18px;\n\n    border: none;\n\n    border-radius: 18px;\n\n    background:\n\n        var(--primary-100);\n\n    color: white;\n\n    font-size: 16px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: .3s;\n\n}\n\n\n.offer-apply-btn:hover {\n\n    background:\n\n        var(--primary-200);\n\n    transform:\n        translateY(-2px);\n\n}\n\n\n@media(max-width:768px) {\n\n    .offer-page {\n\n        padding: 20px;\n\n    }\n\n    .offer-header {\n\n        flex-direction: column;\n        align-items: flex-start;\n\n    }\n\n    .offer-header-info h1 {\n\n        font-size: 24px;\n\n    }\n\n}\n\n\n.role-warning {\n\n    padding: 15px;\n\n    border-radius: 16px;\n\n    background:\n        rgba(239,\n            68,\n            68,\n            0.08);\n\n    color:\n        #dc2626;\n\n    font-weight: 600;\n\n    text-align: center;\n\n}\n\n\n.offer-apply-btn.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    pointer-events: none;\n    filter: grayscale(100%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
